// Fragment "site content rows (2026-10-18 field report)" — the Site content editor rows
// added for a practitioner's report: one hero title instead of three lines, the badge
// above it, the three stats, the story quote, and the per-row notes that say what an
// empty field does. Keys are `content.preset.<key>` / `content.hint.<key>` for the
// lib/siteContent.js SITE_TEXT_OVERRIDES entries. Merged in ./index.js.
export default {
  fr: {
    "content.hiddenOnSite": "Masqué sur votre site",
    "content.preset.hero.title": "Hero · Titre principal",
    "content.preset.hero.stat1": "Hero · Chiffre 1 · Valeur",
    "content.preset.hero.stat1Label": "Hero · Chiffre 1 · Libellé",
    "content.preset.hero.stat2": "Hero · Chiffre 2 · Valeur",
    "content.preset.hero.stat2Label": "Hero · Chiffre 2 · Libellé",
    "content.preset.hero.stat3": "Hero · Chiffre 3 · Valeur",
    "content.preset.hero.stat3Label": "Hero · Chiffre 3 · Libellé",
    "content.preset.story.quote": "Mon parcours · Citation",
    "content.hint.hero.eyebrow": "La petite pastille au-dessus du titre, par exemple « Naturopathe agréée · ND.A · Québec ». Vide : rien n'est affiché.",
    "content.hint.hero.title": "Tout le grand titre. Appuyez sur Entrée pour aller à la ligne (dans le modèle Classique, la deuxième ligne s'affiche en italique). Vide : le titre d'exemple s'affiche.",
    "content.hint.hero.script": "La phrase manuscrite sous le titre. Pour la masquer, videz-la en FR et en EN puis enregistrez ; supprimez-la pour retrouver le texte d'exemple.",
    "content.hint.hero.sub": "Le paragraphe sous la phrase manuscrite. Pour le masquer, videz-le en FR et en EN puis enregistrez ; supprimez-le pour retrouver le texte d'exemple.",
  },
  en: {
    "content.hiddenOnSite": "Hidden on your site",
    "content.preset.hero.title": "Hero · Main title",
    "content.preset.hero.stat1": "Hero · Figure 1 · Value",
    "content.preset.hero.stat1Label": "Hero · Figure 1 · Label",
    "content.preset.hero.stat2": "Hero · Figure 2 · Value",
    "content.preset.hero.stat2Label": "Hero · Figure 2 · Label",
    "content.preset.hero.stat3": "Hero · Figure 3 · Value",
    "content.preset.hero.stat3Label": "Hero · Figure 3 · Label",
    "content.preset.story.quote": "My journey · Quote",
    "content.hint.hero.eyebrow": "The small badge above the title, for example “Registered Naturopath · ND.A · Québec”. Empty: nothing is shown.",
    "content.hint.hero.title": "The whole headline. Press Enter to start a new line (in the Classic design the second line is shown in italics). Empty: the sample headline is shown.",
    "content.hint.hero.script": "The handwritten phrase under the title. To hide it, empty both the FR and EN versions and save; delete it to bring back the sample text.",
    "content.hint.hero.sub": "The paragraph under the handwritten phrase. To hide it, empty both the FR and EN versions and save; delete it to bring back the sample text.",
  },
  es: {
    "content.hiddenOnSite": "Oculto en tu sitio",
    "content.preset.hero.title": "Hero · Título principal",
    "content.preset.hero.stat1": "Hero · Cifra 1 · Valor",
    "content.preset.hero.stat1Label": "Hero · Cifra 1 · Etiqueta",
    "content.preset.hero.stat2": "Hero · Cifra 2 · Valor",
    "content.preset.hero.stat2Label": "Hero · Cifra 2 · Etiqueta",
    "content.preset.hero.stat3": "Hero · Cifra 3 · Valor",
    "content.preset.hero.stat3Label": "Hero · Cifra 3 · Etiqueta",
    "content.preset.story.quote": "Mi recorrido · Cita",
    "content.hint.hero.eyebrow": "La pequeña insignia sobre el título, por ejemplo «Naturópata registrada · ND.A · Quebec». Vacía: no se muestra nada.",
    "content.hint.hero.title": "Todo el titular. Pulsa Intro para pasar a otra línea (en el diseño Clásico la segunda línea se muestra en cursiva). Vacío: se muestra el titular de ejemplo.",
    "content.hint.hero.script": "La frase manuscrita bajo el título. Para ocultarla, vacía las versiones FR y EN y guarda; elimínala para recuperar el texto de ejemplo.",
    "content.hint.hero.sub": "El párrafo bajo la frase manuscrita. Para ocultarlo, vacía las versiones FR y EN y guarda; elimínalo para recuperar el texto de ejemplo.",
  },
};
